import { type DiagnosisViewModel, type OasisDefinitionViewModel, type OasisTaskCommandModel, type OasisTaskViewModel } from '@generated';
import { convertClientValuesToServerValues, getInitialValues } from '~/libraries/forms/values';
import type { FormRegistryValues } from '~/shared/forms/FormRegistryContext';
import type { FormValues } from '~/shared/forms/types';

const today = new Date();

export function getOasisInitialValues(
	oasisTask: { oasisDefinition: OasisDefinitionViewModel; values?: FormValues },
	allOasisTasks: OasisTaskViewModel[],
	stayFindings: string[],
	visitFindings: string[],
	diagnoses: DiagnosisViewModel[] | undefined
): FormValues {
	const initialTaskValues = getInitialValues(oasisTask.oasisDefinition.documentationFormFields, oasisTask.values);
	const externalReferences = oasisTask.oasisDefinition.externalReferences ?? [];
	const externalReferenceTaskValues = allOasisTasks
		.filter(x => x.oasisDefinition.documentationFormFields.some(field => externalReferences.includes(field.name)))
		.reduce((acc, referencedTask) => {
			if (referencedTask.values) {
				acc = { ...acc, ...getInitialValues(referencedTask.oasisDefinition.documentationFormFields, referencedTask.values) };
			}
			return acc;
		}, {} as Record<string, unknown>);

	return {
		...initialTaskValues,
		...externalReferenceTaskValues,
		oasisAssessmentPredefinedValues: {},
		performed: true,
		stayFindings: stayFindings,
		visitFindings: visitFindings,
		diagonsesCodes: diagnoses?.map(diagnosis => diagnosis.icdDiagnosis.code) || []
	};
}

export function convertToServerValues(tasks: OasisTaskViewModel[], formRegisteryValues: FormRegistryValues): { oasisTasks: OasisTaskCommandModel[] } {
	return {
		oasisTasks: tasks.map(task => {
			const values = formRegisteryValues[task.id] ?? {};
			return {
				oasisTaskId: task.id,
				values: convertClientValuesToServerValues(values, task.oasisDefinition.documentationFormFields)!,
				notes: values.notes,
				collaborationAnswerDiverged: values.collaborationAnswerDiverged,
				divergenceReason: values.collaborationAnswerDiverged ? values.divergenceReason : undefined
			};
		})
	};
}
